/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { Injectable } from '@angular/core';
import { I18nService } from '@dm/core';
import { healthStatusE } from 'app/common/constants';
import { type LicenseKey } from 'app/common/constants/license-key';
import { type Observable } from 'rxjs';

export enum GroupTypeE {
    object = 'object',
    operation = 'operations',
    page = 'page',
    help = 'help'
}

export enum HistoryTypeE {
    page = 'searchPageHistory',
    operation = 'searchOperationHistory'
}

/**
 * 所有数据 opt 对象 页面
 */
export enum DataTypeE {
    tenant = 'tenant',
    lunGroup = 'lunGroup',
    lun = 'lun',
    NamespaceGroup = 'NamespaceGroup',
    Namespace = 'Namespace',
    recycleBin = 'recycleBin',
    hostGroup = 'hostGroup',
    host = 'host',
    initiator = 'initiator',
    portGroup = 'portGroup',
    peLun = 'peLun',
    vvolLun = 'vvolLun',
    vvolPg = 'vvolPg',
    channelLun = 'channelLun',
    mappingView = 'mappingView',
    fs = 'fileSystems',
    dtree = 'dtree',
    nfsShare = 'nfsShare',
    cifsShare = 'cifsShare',
    dataTurboShare = 'dataTurboShare',
    unixUser = 'unixUser',
    windowsUser = 'windowsUser',
    userMapping = 'userMapping',
    quota = 'quota',
    quotaReports = 'quotaReports',
    logicPort = 'logicPort',
    ethNetwork = 'ethNetwork',
    bindPorts = 'bindPorts',
    ethVlan = 'ethVlan',
    failoverGroups = 'failoverGroups',
    vSwitch = 'vSwitch',
    rocePorts = 'rocePorts',
    roceVlan = 'roceVlan',
    roceFailoverGroups = 'roceFailoverGroups',
    fcNet = 'fcNet',
    netSpace = 'netSpace',
    smartCache = 'smartCache',
    smartQos = 'smartQos',
    smartMigration = 'smartMigration',
    intraSmartMigration = 'intraSmartMigration',
    extraSmartMigration = 'extraSmartMigration',
    intraSmartMove = 'intraSmartMove',
    extraSmartMove = 'extraSmartMove',
    smartMoveDomain = 'smartMoveDomain',
    smartMoveVstorePair = 'smartMoveVstorePair',
    smartMoveFsPair = 'smartMoveFsPair',
    cloudTier = 'cloudTier',
    tierPolicy = 'tierPolicy',
    tierDev = 'tierDev',
    tierLocalIpgroup = 'tierLocalIpgroup',
    tierRemoteIpgroup = 'tierRemoteIpgroup',
    protectVstore = 'protectVstore',
    remoteRepPairVstore = 'remoteRepPairVstore',
    hypermetroPairVstore = 'hypermetroPairVstore',
    protectGroup = 'protectGroup',
    snapshotGroup = 'snapshorGroup',
    cloneGroup = 'cloneGroup',
    repGroup = 'repGroup',
    hyperMetroGroup = 'hyperMetroGroup',
    drStarGroup = 'drStarGroup',
    protectLun = 'protectLun',
    lunSnapshot = 'lunSnapShot',
    clone = 'clone',
    lunRep = 'lunRep',
    lunHyperMetro = 'lunHyperMetro',
    drStar = 'drStar',
    protectFs = 'protectFs',
    fsSnapshot = 'fsSnapShot',
    fsClone = 'fsClone',
    fsRep = 'fsRep',
    fsHyperMetro = 'fsHyperMetro',
    timeBlockCdp = 'timeBlockCdp',
    blockCdpGroup = 'blockCdpGroup',
    blockCdp = 'blockCdp',
    timeFsCdp = 'timeFsCdp',
    fsCdp = 'fsCdp',
    remoteDevice = 'remoteDevice',
    hyperMetroDomain = 'hyperMetroDomain',
    alarm = 'alarm',
    event = 'event',
    DIAGNOSIS_TASK = 'diagnosisTask',
    dashboard = 'dashboard',
    analysis = 'analysis',
    anomaly = 'anomaly',
    powerConsumption = 'powerConsumption',
    forecasting = 'forecasting',
    capacityForecast = 'capacityForecast',
    performanceForecast = 'performanceForecast',
    dataExport = 'dataExport',
    taskCenter = 'taskCenter',
    hardware = 'hardware',
    device = 'device',
    externalStorage = 'externalStorage',
    storagePool = 'storagePool',
    deviceInfo = 'deviceInfo',
    systemTime = 'systemTime',
    dnsService = 'dnsService',
    blockService = 'blockService',
    NDMPService = 'NDMPService',
    auditLog = 'auditLog',
    manageLicense = 'manageLicense',
    certificateManagement = 'certificateManagement',
    certificateAuto = 'certificateAuto',
    builtInCa = 'builtInCa',
    keyService = 'keyService',
    user = 'user',
    role = 'role',
    securityPolicy = 'securityPolicy',
    manageLdap = 'manageLdap',
    ldapDomain = 'ldapDomain',
    nisDomain = 'nisDomain',
    adDomain = 'adDomain',
    multifactorAuthen = 'multifactorAuthen',
    ssoServer = 'ssoServer',
    alarmNotification = 'alarmNotification',
    dumpAlarm = 'dumpAlarm',
    maskAlarm = 'maskAlarm',
    eventNotification = 'eventNotification',
    alarmSeverity = 'alarmSeverity',
    snmpProtocol = 'snmpProtocol',
    snmpSecurityPolicy = 'snmpSecurityPolicy',
    monitorSetting = 'monitorSetting',
    eService = 'eService',
    Container = 'Container',
    emailService = 'emailService',
    upgrade = 'upgrade',
    netwrkPlane = 'networkPlane',
    antivirus = 'antivirus',
    nfsService = 'nfsService',
    performanceLayer = 'performanceLayer',
    cifsService = 'cifsService',
    dataTurboClient = 'dataTurboClient',
    chart = 'chart',
    image = 'image',
    application = 'applicaion',
    containerSevice = 'containerSevice',
    pod = 'pod',
    pv = 'pv',
    nfsClient = 'nfsClient',
    reportTemplate = 'reportTemplate',
    VIRTUAL_MACHINE = 'virtualMachine',
    AUDIT_LOG_EXPORT = 'auditLogExport',
    SWITCH_PORT = 'switchPort',
}

export interface SearchData {
    /**
     * 查询关键字
     */
    searchKey: string;
    /**
     * 页面显示字段
     */
    name?: string;
    /**
     * 对象类型描述:LUN001(类型描述)
     */
    objectDes?: string;
    /**
     * 所属type
     */
    type: string | number;
    /**
     * 所属group
     */
    groupType?: string;
    /**
     * 所属点击跳转地址
     */
    url: string;
    /**
     * tab标签页
     */
    tab?: string;
    /**
     * 二级tab标签页
     */
    subTab?: string;
    /**
     * 执行操作
     */
    action?: string;
    /**
     * 路由跳转参数
     */
    actionParams?: string;
    /**
     * 是否为快捷推荐内容
     */
    defaultSearch?: boolean;
    /**
     * 是否为高级搜索快捷推荐内容
     */
    defaultAdvancedSearch?: boolean;
    advancedType?: string;
    /**
     * 是否为对象
     */
    isObject?: boolean;
    /**
     * 用于上下箭头快捷键
     */
    selected?: boolean;
    /**
     * 是否支持NAS。在Dorado 3000/5300产品型号中不支持NAS，启动DM时在before_start.py中会将该值设置为false
     */
    isNASFeature?: boolean;
    /**
     * 是否显示
     */
    show?: boolean;
    /**
     * 对象详情tip展示
     */
    tips?: any;
    vstoreId?: any;
    vstoreName?: any;
    local?: any;
}

export interface SearchObj {
    id: string;
    name: string;
    precisionType: string;
    COMBINATION: string;
}

export interface SearchResult {
    id: string;
    name: string;
    precisionType: string;
    vstoreId: string;
    vstoreName: string;
}

export interface SearchEvent {
    baseCount: number;
    sourceData: { [key: string]: SearchData[] };
    more: boolean;
    value: string;
}

export interface HelpResult {
    groupType: string;
    id: number;
    local: string;
    name: string;
    path: string;
}

export interface DataConfig {
    type: string;
    url: string;
    tab?: string;
    subTab?: string;
    license?: Array<LicenseKey | LicenseKey[]>;
    isNASFeature?: boolean;
    isSmartGUIFeature?: boolean;
    isContainerFeature?: boolean;
    isFsHyperMetroFeature?: boolean;
    isNotSupportFeatureInOceanMicro?: boolean;
    operation?: DataConfigOperation[];
    page: DataConfigPage;
    getCombinationObservable?: (parm: string) => Observable<Tip[]>;
    objectDes?: string;
    noFcFeature?: boolean;
    noBondFeature?: boolean;
    noRoceFeature?: boolean;
    hide?: boolean;
}

export interface DataConfigOperation {
    searchKey: string;
    action: string;
    actionParams?: string;
    permission?: string[] | string[][];
    license?: Array<LicenseKey | LicenseKey[]>;
    defaultSearch?: boolean;
    noOem?: boolean;
    noProdRelease?: boolean;
    notSupportFsHyperMetroDomainFeature?: boolean;
    noCreateStoragePoolFeature?: boolean;
    noRestartShutDownFeature?: boolean;
    noFcFeature?: boolean;
    noBondFeature?: boolean;
    noRoceFeature?: boolean;
    hide?: boolean;
}

export interface DataConfigPage {
    searchKey: string;
    permission?: string[] | string[][];
    license?: Array<LicenseKey | LicenseKey[]>;
    defaultSearch?: boolean;
    defaultAdvancedSearch?: boolean;
    advancedType?: string;
    noOem?: boolean;
    noProdRelease?: boolean;
    notSupportFsHyperMetroDomainFeature?: boolean;
    noFcFeature?: boolean;
    noBondFeature?: boolean;
    noRoceFeature?: boolean;
}

export interface Tip {
    /**
     * 标签
     */
    label: string;
    /**
     * 显示的值
     */
    value?: string;
    /**
     * 显示健康状态红绿灯
     */
    status?: number;
    /**
     * 显示的图标
     */
    icons?: string[];
}

export const DEBOUNCE_TIME = 200;
export const HEALTH_STATUS = healthStatusE;

/**
 * 每次点击更多时，叠加的数据条数
 */
export const INCREMENT = 20;

/**
 * 快捷键
 */
export const DOWN_ARROW = 40;
export const UP_ARROW = 38;
export const ENTER = 13;

export enum DataURL {
    // 查询租户
    vstore = 'vstore.get',
    // 查询单个LUN组
    lungroup = 'lunGroup.get',
    // 查询单个LUN
    lun = 'lun.get',
    // 回收站
    recyclebin = 'lun.associate',
    // 查询主机详情
    host = 'host.get',
    // 查询主机组详情
    hostgroup = 'hostGroup.get',
    // 查询端口组详情
    portgroup = 'portGroup.get',
    // 查询单个文件系统
    fs = 'fileSystem.get',
    // 查询单个Dtree
    dtree = 'dtree.get',
    // 查询单个nfs共享
    nfsshare = 'NFSShare.get',
    // 查询单个cifs共享
    cifsshare = 'CIFSShare.get',
    // 查询单个dataTurbo共享
    dataTurboshare = 'DataTurboShare.get',
    // 查询单个Quota
    quota = 'quota.get',
    // 查询逻辑端口
    lif = 'lif.get',
    // 查询NetSpace
    netSpace = 'netSpace.get',
    // 查询单个lun快照
    lunsnapshot = 'snapshot.get',
    // 查询单个clone
    clone = 'clone.get',
    // 单个查询lun远程复制pair
    replicationpair = 'replicationPair.get',
    // 查询双活Pair
    hypermetropair = 'hyperMetroPair.get',
    // 查询文件系统双活pair
    fshypermetropair = 'fsHyperMetroPair.get',
    // 单个查询fs快照
    fssnapshot = 'fsSnapshot.get',
    // 查询HyperCDP
    hypercdp = 'hyperCdp.get',
    // 查询ldap domain
    ldapdomain = 'serviceLdap.get',
    // 查询nis domain
    nisdomain = 'serviceNis.get',
    // 查询AD域设置
    addomain = 'serviceAd.get',
    // 查询对象
    object = 'globalSearch.get'
}

@Injectable({ providedIn: 'root' })
export class GlobalSearchStrService {
    get = this.i18nService.get;

    i18n = {
        nodataTipLabel: this.get('home.search_term_noData_tip'),
        tips: this.get('home.search_term_tip'),
        placeholder: this.get('home.search_term_type_info'),
        operationTag: this.get('common.operation_button'),
        pageTag: this.get('home.search_term_page_lab'),
        helpTag: this.get('home.Help_task_help_label'),
        moreButton: this.get('common.more_button'),
        used: this.get('storage.storagePool_expand_task_used_label'),
        mapped: this.get('common.mapping_mapped_value'),
        unMapped: this.get('common.mapping_unMapped_value'),
        iPAddresses: this.get('common.IPAddresses_lab'),
        noIP: this.get('home.search_term_noIP_tip'),
        loading: this.get('common.loading_label'),
        advancedSearchTip: this.get('home.search_term_advanceSearch_tip'),

        portNumLab: (num: number): string => this.get('home.search_term_portsNum_tip', [num]),
        fileNumLab: (num: number): string => this.get('home.search_term_filesNum_tip', [num]),
        hostNumLab: (num: number): string => this.get('home.search_term_hostsNum_tip', [num]),
        healthStatusLab: this.get('system.healthStatus_column', true),
        pairHealthStatusLab: this.get('protection.hyperMetroCG_term_pairHealthStatus_column', true),
        usageLab: this.get('common.allocatedCapacity_lab', true),
        mapStatusLab: this.get('common.mapping_column', true),
        protectLab: this.get('common.dataProtection_title', true),
        ipLab: this.get('common.IPaddress_column', true),
        activeStatusLab: this.get('common.status_column', true),
        runStatusLab: this.get('system.runningStatus_column', true),
        pairRunStatusLab: this.get('protection.hyperMetroCG_term_pairRunningStatus_column', true),
        protocolLab: this.get('system.logicPort_task_create_dataProtocol_label', true),
        sourceLunLab: this.get('common.sourceLun_label', true),
        fsCountLab: this.get('service.vstore_task_view_fsNum_column', true),
        hostCountLab: this.get('host.hostGroup_term_hostsNum_lab', true),
        portCountLab: this.get('host.portGroup_term_portsNum_cloum', true),
        portIdLab: this.get('common.portID_lab', true),
        shareLab: this.get('common.share_lab', true),
        quotaLab: this.get('common.quota_lab', true),
        sharePathLab: this.get('service.share_term_sharePath_lab', true),
        spaceHardquotaLab: this.get('service.quota_term_create_spaceHardQuota_column', true),
        fileHardquotaLab: this.get('service.quota_term_create_fileNumberHardQuota_column', true),
        repModLab: this.get('common.copyMode_label', true),
        snapTypeLab: this.get('protection.fs_hyperClone_task_create_hyperSnapType_label', true),
        createTimeLab: this.get('common.createTime_label', true),
        activeTimeLab: this.get('protection.snapshotCG_term_activatePointTime_column', true),
        scheduleLab: this.get('protection.HyperCDP_term_timing_column', true),
        domainNameLab: this.get('settings.domainAuth_term_NISDomain_domainName_lab', true),

        lunTab: this.get('common.LUNs'),
        lunGroupTab: this.get('common.lunGroup_title'),
        recycleBinTab: this.get('storage.recycleBin_task_title'),
        hostGroupTab: this.get('common.hostGroups_title'),
        hostTab: this.get('common.hosts_title'),
        initiatorTab: this.get('host.host_term_initiators_tab'),
        peLunTab: this.get('storage.vvol_task_PELUN_tab'),
        vvolLunTab: this.get('storage.vvol_task_vvolLUN_tab'),
        vvolPgTab: this.get('storage.vvol_task_vvolPG_tab'),
        channelLunTab: this.get('storage.channelLUN_task_title'),
        nfsShareTab: this.get('common.nfsShare_lab'),
        cifsShareTab: this.get('common.cifsShare_lab'),
        dataTurboShareTab: this.get('common.DataTurboShare_lab'),
        cloudTierTab: this.get('service.Cloudtier_task_title'),
        intraSmartMoveTab: this.get('storage.smartMigration_term_withinArray_tab'),
        extraSmartMoveTab: this.get('storage.smartMigration_term_betweenArray_tab'),
        smartMoveDomainTab: this.get('storage.smartMove_task_domain_tab'),
        smartMoveVstorePairTab: this.get('storage.smartMove_task_vstorePair_tab'),
        smartMoveFsPairTab: this.get('storage.smartMove_task_fsPair_tab'),
        policyTab: this.get('service.Cloudtier_task_policyTemple_tab'),
        tierDevTab: this.get('system.LIF_task_view_Preferred_remote_value'),
        tierLocalIpgroupTab: this.get('service.Cloudtier_task_remoteDevice_localIPGroup_lab'),
        tierRemoteIpgroupTab: this.get('service.Cloudtier_task_remoteDevice_remoteIPGroup_lab'),
        unixUserTab: this.get('service.accessUser_UNIXUsers_lab'),
        windowsUserTab: this.get('service.accessUser_WindowsUsers_lab'),
        userMappingTab: this.get('service.userMapping_task_title'),
        quotaTab: this.get('service.quota_term_userQuotas_tittle'),
        quotaReportsTab: this.get('service.quota_term_quotaReports_tittle'),
        ethNetworkTab: this.get('system.network_term_etherPorts_tab'),
        bindPortsTab: this.get('system.network_term_bondPorts_tab'),
        ethVlanTab: this.get('system.hardware_term_VLANs_tab'),
        failoverGroupsTab: this.get('system.network_term_failoverGroups_tab'),
        vSwitchTab: this.get('compute.service_network_vSwitch_tab'),
        rocePortsTab: this.get('system.network_term_rocePorts_tab'),
        roceVlanTab: this.get('system.hardware_term_VLANs_tab'),
        roceFailoverGroupsTab: this.get('system.network_term_failoverGroups_tab'),
        protectVstoreTab: this.get('service.vstore_term_vstores_title'),
        remoteRepPairVstoreTab: this.get('protection.vstore_task_view_remoteRepPairs_tab'),
        hypermetroPairVstoreTab: this.get('protection.vstore_task_view_hypermetroPairs_tab'),
        protectionGroupTab: this.get('protection.protectionGroup_title'),
        snapshotCGTab: this.get('protection.snapshotCGs_title'),
        cloneCGTab: this.get('protection.cloneCG_title'),
        replicationCGTab: this.get('protection.replicationCG_title'),
        hyperMetroCGroupTab: this.get('protection.hyperMetroCGs_title'),
        hyperMetroDomainTab: this.get('common.HyperMetroDomains_title'),
        drStarPgTab: this.get('protection.dataProtection_term_drStarTrios'),
        protectLunTab: this.get('common.lun_title'),
        lunSnapshotTab: this.get('common.snapshots'),
        cloneTab: this.get('common.clonePairs'),
        lunRepTab: this.get('common.RemoteReplicationPairs'),
        lunHyperMetroTab: this.get('common.HyperMetroPairs'),
        drStarTab: this.get('protection.dataProtection_term_drStarTrios'),
        protectFsTab: this.get('common.fileSystem_title'),
        fsSnapshotTab: this.get('common.snapshots'),
        fsCloneTab: this.get('protection.fs_hyperClone_task_clones_title'),
        fsRepTab: this.get('common.RemoteReplicationPairs'),
        fsHyperMetro: this.get('protection.fs_hyperMetro_task_create_pair_lab'),
        blockTimeCdpTab: this.get('protection.HyperCDPCG_term_timing_schedules_column'),
        blockCdpGroupTab: this.get('protection.HyperCDPCG_column'),
        blockCdpTab: this.get('protection.HyperCDP_Objects_column'),
        fsTimeCdpTab: this.get('protection.HyperCDPCG_term_timing_schedules_column'),
        fsCdpTab: this.get('protection.HyperCDP_Objects_column'),
        alarmTab: this.get('monitor.alarm_term_realTime_label'),
        eventTab: this.get('monitor.alarm_term_type_event_label'),
        capacityForecastTab: this.get('monitor.forecasting_task_capForecast_tab'),
        performanceForecastTab: this.get('common.forecasting_title'),
        resourceListTab: this.get('system.hardware_term_resourceList_tab'),
        deviceTab: this.get('system.Devices_tab'),
        userTab: this.get('settings.userAndRole_task_Users_title'),
        roleTab: this.get('settings.userAndRole_task_Roles_title'),
        manageLdapTab: this.get('settings.domainAuth_term_manageLDAP_tittle'),
        ldapDomainTab: this.get('settings.domainAuth_term_serviceLDAP_tittle'),
        nisDomainTab: this.get('settings.domainAuth_term_serviceNIS_tittle'),
        adDomainTab: this.get('settings.domainAuth_term_serviceAD_title'),
        upgradeTab: this.get('common.upgrade_label'),
        performanceLayersTab: this.get('storage.storagePool_create_task_performanceLayers_tab'),
        storagePoolTitle: this.get('common.storagePool_title'),
        serviceTitle: this.get('common.service_title'),
        dataProtectionTitle: this.get('common.dataProtection_title'),
        monitorTitle: this.get('common.monitor_title'),
        enabled: this.get('common.service_enable_value'),
        disabled: this.get('common.disabled_label'),
        certificateManagement: this.get('common.certificateManagement_title'),
        certificateAuto: this.get('settings.systemSetting_task_caAutoApply_title'),
        builtInCaTitle: this.get('内置CA'),
        chartsTab: this.get('system.container_repository_task_charts_tab'),
        imagesTab: this.get('system.container_repository_task_images_tab'),
        applicationTab: this.get('system.container_app_task_title'),
        intraTiltle: this.i18nService.get('storage.smartMigration_term_withinArray_tab'),
        extraTtitle: this.i18nService.get('storage.smartMigration_term_betweenArray_tab'),
        dataExportTaskTab: this.i18nService.get('monitor.dataExport_task_tab'),
        dataExportTemplateTab: this.i18nService.get('monitor.dataExport_template_tab'),
        auditLogManagerTab: this.get('settings.auditLog_task_title_management'),
        auditLogExportTab: this.get('settings.auditLog_task_title_export_to_auditLog'),
    };

    /**
     * status映射
     */
    statusMap = {
        /**
         * 1:正常
         */
        [HEALTH_STATUS.Normal.value]: {
            color: '#7ADFA0',
            label: this.i18nService.get(HEALTH_STATUS.Normal.i18n),
        },
        /**
         * 2:故障
         */
        [HEALTH_STATUS.Fault.value]: {
            color: '#f45c5e',
            label: this.i18nService.get(HEALTH_STATUS.Fault.i18n),
        },
        /**
         * 15:写保护
         */
        [HEALTH_STATUS.WriteProtect.value]: {
            color: '#7ADFA0',
            label: this.i18nService.get(HEALTH_STATUS.WriteProtect.i18n),
        },
        /**
         * 17:无冗余路径
         */
        [HEALTH_STATUS.NoRedundantLink.value]: {
            color: '#7ADFA0',
            label: this.i18nService.get(HEALTH_STATUS.NoRedundantLink.i18n),
        },
        /**
         * 18:离线
         */
        [HEALTH_STATUS.OFFLINE.value]: {
            color: '#f45c5e',
            label: this.i18nService.get(HEALTH_STATUS.OFFLINE.i18n),
        },
    };

    constructor(private i18nService: I18nService) {
    }
}
